var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWebsite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web",
    transform: "translate(1478 570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M-1475.6-567.6c1.4-1.6,3.5-2.5,5.6-2.4c2.1-0.1,4.2,0.8,5.6,2.4c1.6,1.4,2.5,3.5,2.4,5.6 c0.1,2.1-0.8,4.2-2.4,5.6c-1.4,1.6-3.5,2.5-5.6,2.4c-2.1,0.1-4.2-0.8-5.6-2.4c-1.5-1.5-2.4-3.5-2.4-5.6 C-1478.1-564.1-1477.2-566.2-1475.6-567.6z M-1468.9-555.6c0.8-0.1,1.5-0.6,2-1.2c0.5-0.8,0.9-1.8,0.9-2.8c0-0.6-0.2-1.2-0.7-1.6 c-0.4-0.5-1.1-0.8-1.7-0.8h-1.3c-0.4,0-0.8-0.1-1.2-0.3c-0.3-0.2-0.4-0.6-0.4-0.9c0-0.2,0.1-0.4,0.3-0.5c0.1-0.1,0.3-0.2,0.5-0.3 c0.3,0,0.5,0.2,0.7,0.4c0.3,0.1,0.4,0.3,0.5,0.3c0.2,0,0.4,0,0.5-0.1c0.1-0.2,0.2-0.3,0.1-0.5c-0.1-0.5-0.3-1-0.7-1.3 c0.4-0.8,0.7-1.6,0.7-2.5c0-0.1-0.1-0.3-0.3-0.3c-0.3-0.1-0.7-0.2-1.1-0.3c-1.2,0-2.4,0.4-3.5,1.1c-0.8,0.7-1.2,1.6-1.2,2.7 c0,1,0.4,1.9,1.1,2.5c0.7,0.7,1.6,1.1,2.5,1.1l0,0v0.5c0,0.5,0.2,1,0.5,1.3c0.3,0.4,0.7,0.7,1.2,0.8v2.4c0,0.1,0,0.1,0.1,0.3 C-1469.1-555.6-1469.1-555.6-1468.9-555.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebsite);
export default __webpack_public_path__ + "static/media/icon_website.3fee7d992378c997a9b3b871a9a21aea.svg";
export { ForwardRef as ReactComponent };